// removed by extract-text-webpack-plugin
module.exports = {"root":"_2TrWgSi","heading":"_2jgxmBb","ul":"_1x7a4UD","li":"_1WcvYFj"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/ZeroResults/ZeroResults.less
 ** module id = 828
 ** module chunks = 0
 **/